import type { MediaAsset, PlaylistItem } from '@ghostscreen/contracts';
import { i18n } from '../../i18n/i18n';

export function isVideoAsset(
  asset: Pick<MediaAsset, 'kind' | 'contentType'> | null | undefined,
): boolean {
  if (!asset) return false;
  if (asset.kind === 'video') return true;
  return asset.contentType.toLowerCase().startsWith('video/');
}

/**
 * URL for full-size preview (lightbox / Manage slide).
 * Videos must use the H.264 `playbackUrl` — `previewUrl` is the JPEG poster.
 */
export function getMediaPreviewPlayUrl(
  asset: Pick<MediaAsset, 'kind' | 'previewUrl' | 'playbackUrl'> | null | undefined,
): string | null {
  if (!asset) return null;
  if (asset.kind === 'video') return asset.playbackUrl ?? null;
  return asset.previewUrl ?? null;
}

/**
 * Playlist draft tiles store a dwell seconds value used for images.
 * Videos ignore that on the player and run to natural end — label accordingly.
 */
export function formatPlaylistItemScreenTime(
  item: Pick<PlaylistItem, 'durationSeconds'>,
  asset: Pick<MediaAsset, 'kind' | 'contentType' | 'durationSeconds'> | undefined,
): string {
  if (!isVideoAsset(asset)) {
    return i18n.t('content:screenTime.onScreen', { seconds: item.durationSeconds });
  }

  const probed = asset?.durationSeconds;
  if (probed != null && Number.isFinite(probed) && probed > 0) {
    return i18n.t('content:screenTime.fullLengthApprox', { seconds: Math.round(probed) });
  }
  return i18n.t('content:screenTime.fullLength');
}
